import TemplateTestSendModal from './TemplateTestSendModal';

export default TemplateTestSendModal;
